export default "__VITE_ASSET__BkrMroqX__"